import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "content has-text-centered" }, [
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, "Buefy Firebase Auth"),
        _createTextVNode(" by "),
        _createElementVNode("a", { href: "https://www.berviantoleo.my.id" }, "Bervianto Leo Pratama"),
        _createTextVNode(". The source code is licensed "),
        _createElementVNode("a", { href: "http://opensource.org/licenses/mit-license.php" }, "MIT"),
        _createTextVNode(". The website content is licensed "),
        _createElementVNode("a", { href: "http://creativecommons.org/licenses/by-nc-sa/4.0/" }, "CC BY NC SA 4.0"),
        _createTextVNode(". ")
      ])
    ], -1)
  ]))]))
}